import { Users } from '@orgus/ui/icons';
import type { ReactNode } from 'react';
import type { TeamsState } from '@orgus/protocol';
import { EmptyState, ErrorState, SkeletonRows } from '@orgus/ui';
import { loadState } from '../../lib/data.ts';
import { useTeams } from './model.ts';

/** Loading, a hub without the teams module, a failed load, or the content. */
export function TeamsGate({ label, children }: { label: string; children: (data: TeamsState) => ReactNode }) {
  const { status, data, error } = useTeams();
  if (status === 'loading') {
    return (
      <div className="flex flex-col gap-4" role="status" aria-label={`Loading ${label}`}>
        <SkeletonRows rows={2} />
        <SkeletonRows rows={4} />
      </div>
    );
  }
  if (status === 'error') return <ErrorState error={error} onRetry={() => loadState()} />;
  if (status === 'unsupported' || !data) {
    return (
      <EmptyState
        icon={<Users />}
        title="This hub has no teams module"
        description="Teams, owners, routing and presence come with a newer hub. Update Orgus on the hub machine, restart it, then reload this page."
      />
    );
  }
  return <>{children(data)}</>;
}
